import { gql } from '@apollo/client'
import ORGANIZATION_TPA_FRAGMENT from 'apollo/fragments/ORGANIZATION_TPA_FRAGMENT'

// ORGANIZATION_FOR_SELECT

export default gql`
  query organization_from_id_for_select($id: ID!) {
    organizationOption: organization_from_id(id: $id) {
      id
      ...ORGANIZATION_TPA_FRAGMENT
    }
  }
  ${ORGANIZATION_TPA_FRAGMENT}
`
